import type { SuburbInput } from "@repo/adapter-core";
import { replacePathPageSegment, slugify } from "@repo/adapter-core";
import type { RealestateAdapterConfig } from "./config.ts";

const LISTING_TYPE_PATHS: Record<string, string> = {
  sold: "/sold/in-",
  buy: "/buy/in-",
  rent: "/rent/in-",
};

const REALESTATE_PROPERTY_TYPE_PATHS: Record<string, string> = {
  house: "property-house-in-",
  "apartment-unit-flat": "property-unit+apartment-in-",
  townhouse: "property-townhouse-in-",
  villa: "property-villa-in-",
  land: "property-land-in-",
  acreage: "property-acreage-in-",
  rural: "property-rural-in-",
};

export function buildSearchUrl(suburb: SuburbInput, config: RealestateAdapterConfig): string {
  const basePath = LISTING_TYPE_PATHS[config.listingType] || LISTING_TYPE_PATHS.sold;
  const singlePropertyType =
    config.propertyTypes.length === 1 ? config.propertyTypes[0] : undefined;
  const propertyTypePath = singlePropertyType
    ? REALESTATE_PROPERTY_TYPE_PATHS[singlePropertyType]
    : undefined;
  const locationPart = `${slugify(suburb.locality)}%2c+${suburb.state.toLowerCase()}+${suburb.postcode}`;
  const pathPrefix = propertyTypePath ? basePath.replace("/in-", `/${propertyTypePath}`) : basePath;
  return `https://www.realestate.com.au${pathPrefix}${locationPart}/list-1`;
}

export function buildPaginatedUrl(searchUrl: string, page: number): string {
  return replacePathPageSegment(searchUrl, page);
}
